import { createApi } from "./_request";

// 热门推荐
export const hotProductList = createApi({
  url: "/commodity/shop-product/anonymous/hot-list",
});
// 产品列表
export const productList = createApi({
  url: "/commodity/shop-product/anonymous/front-list",
});

// 理赔案例列表
export const claimCaseList = createApi({
  url: "/commodity/ClaimCase/anonymous/list",
});

// 理赔案例详情
export const claimCaseDetail = createApi({
  url: "/commodity/ClaimCase/anonymous/detail/:id",
});

// 个人资料获取
export const getProfile = createApi({
  url: "/order/customer-detail/frontend/profile",
});

// 个人资料修改
export const updateProfile = createApi({
  url: "/order/customer-detail/frontend/profile",
  method: "post",
});

// 通用物料详情
export const generalPurposeMaterialRetrieve = createApi({
  url: "/base/general-material-info/anonymous/detail/:id",
});

// 我的保障数量
export const userPolicyCount = createApi({
  url: "/order/order/frontend/user-policy-count",
});

// 精选保险展示列表
export const goodInsuranceList = createApi({
  url: "/base/InsuranceProductInfo/anonymous/front-list",
})
